const stores = {

  "Apple 1": {

    name: "Apple 1 Smoke Shop",

    address:
      "Austin, Texas, United States",

    phone:
      "+1 (512)-294-2730",

    email:
      "apple1@shopat1stop.com"
  },

  "Apple 2": {

    name: "Apple 2 Smoke Shop",

    address:
      "6401 S. 1st Street, 78745",

    phone:
      "+1 (512)-494-9400",

    email:
      "apple2@shopat1stop.com"
  }

};

export default stores;